import loadable from '@loadable/component';

export const RichContentArea = loadable(() => import('../RichContentArea'));
